import {
  DevelopmentTool,
  DeploymentHostType,
} from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { NonTypeTab, TemplateTab } from '../types/TemplateTabs';

export const DOCS: Partial<Record<TemplateTab, string>> = {
  [DevelopmentTool.BLOCKS]:
    'https://dev.wix.com/docs/build-apps/wix-blocks/getting-started/welcome-to-wix-blocks',
  [DevelopmentTool.CLI]:
    'https://dev.wix.com/docs/build-apps/developer-tools/cli/get-started/about-the-wix-cli-for-apps',
  [DevelopmentTool.DEV_CENTER]:
    'https://dev.wix.com/docs/build-apps/developer-tools/developers-center/get-started-with-the-wix-developers-center',
  [NonTypeTab.ALL]:
    'https://dev.wix.com/docs/build-apps/developer-tools/overview/developer-tools-overview',
};

export const ROUTES = {
  NodeJS: 'https://nodejs.org/en/',
  NpmDocs: 'https://www.npmjs.com/get-npm',
  YarnDocs: 'https://yarnpkg.com/en/docs/install',
  WixDeveloperAccount: 'https://users.wix.com/signin?loginDialogContext=signup',
  appChecksAndTestingDocs:
    'https://dev.wix.com/docs/build-apps/build-your-app/testing/app-checks-and-testing-guide',
  devCenterExtensionsPage: (appId: string) =>
    `https://dev.wix.com/apps/${appId}/extensions`,
  loginPage: (returnedUrl: string, referralInfo: string) => {
    return `https://users.wix.com/signin?loginDialogContext=login&referralInfo=${referralInfo}&postLogin=${returnedUrl}&postSignUp=${returnedUrl}`;
  },
};
export const DEPLOY_APP_LINK_DOC: Partial<Record<DeploymentHostType, string>> =
  {
    [DeploymentHostType.VERCEL]:
      'https://vercel.com/docs/deployments/generated-urls',
    [DeploymentHostType.NETLIFY]:
      'https://docs.netlify.com/domains-https/custom-domains/',
  };

export const ENV_VARIABLE_DOC: Partial<Record<DeploymentHostType, string>> = {
  [DeploymentHostType.VERCEL]:
    'https://vercel.com/docs/projects/environment-variables/system-environment-variables',
  [DeploymentHostType.NETLIFY]:
    'https://docs.netlify.com/environment-variables/overview/',
};

export const DEPLOY_APP_VENDOR_SITE: Partial<
  Record<DeploymentHostType, string>
> = {
  [DeploymentHostType.VERCEL]: 'https://vercel.com/',
  [DeploymentHostType.NETLIFY]: 'https://www.netlify.com/',
};

export const APP_PAGES = {
  OPEN_BLOCKS_TEMPLATE_ROUTE: '/open-blocks-template',
  TEMPLATES_MAIN_PAGE: '/',
  TEMPLATE_PAGE: '/template',
};

export const APP_BASE_ROUTE = `/apps-templates`;

export const REFERRAL_INFO = {
  SELF_HOSTED_MODAL: 'SELF-HOSTED-MODAL',
  BLOCKS_TEMPLATE_FLOW: 'BLOCKS-TEMPLATE-FLOW',
};
